/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

// window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./vue-components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
//     data: {

//     }
// });

require("jquery-mask-plugin");

import SelectStyles from "./components/SelectStyles";
import ScrollToId from "./components/ScrollToId";
import Confirm from "./components/Confirm";
import AjaxForm from "./components/AjaxForm";
import AutoSubmit from "./components/AutoSubmit";
import DatePicker from "./components/DatePicker";
import SubmitOnLoad from "./components/SubmitOnLoad";
import AddressLookup from "./components/AddressLookup";
import Slider from "./components/Slider";
import ScreeningSurvey from "./components/ScreeningSurvey";
import ToggleTrialReferrer from "./components/ToggleTrialReferrer";
import FileUploader from "./components/FileUploader";
import GpPracticeSelector from "./components/GpPracticeSelector";

(function($) {
    var App = {
        // All pages
        common: {
            init: function() {
                new SelectStyles();
                new ScrollToId().onClick();
                new Confirm();
                new AjaxForm();
                new AutoSubmit();
                new DatePicker();
                new SubmitOnLoad();
                new AddressLookup();
                new Slider();
                new ScreeningSurvey();
                new ToggleTrialReferrer();
                new FileUploader();
                new GpPracticeSelector();
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var namespace = App;
            funcname = funcname === undefined ? "init" : funcname;
            if (
                func !== "" &&
                namespace[func] &&
                typeof namespace[func][funcname] === "function"
            ) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            UTIL.fire("common");
            $.each(
                document.body.className.replace(/-/g, "_").split(/\s+/),
                function(i, classnm) {
                    UTIL.fire(classnm);
                }
            );
        }
    };
    $(document).ready(UTIL.loadEvents());
})(jQuery); // Fully reference jQuery after this point.
